import { toast } from "@/components/ui/use-toast";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useReverseDivergenceMutation } from "@/services/divergence";
import { extractRtkErrorMessage } from "@/utils/extract-rtk-error";

import {
  ReversalEffect,
  ReversibleDivergence,
  reversalEffectOf,
} from "../../utils/reversal-effect";
import { REVERSAL_LABELS } from "../../utils/reversal-messages";
import { ReversalModal } from "./reversal-modal";

interface ReversalConfirmationModalProps {
  divergence: ReversibleDivergence & { id: number; version: number };
  openCycle: string;
}

export function ReversalConfirmationModal({
  divergence,
  openCycle,
}: ReversalConfirmationModalProps): JSX.Element {
  const { handleModal } = useDialogModal();
  const [reverseDivergence, { isLoading }] = useReverseDivergenceMutation();

  const effect: ReversalEffect = reversalEffectOf(divergence, openCycle);

  const confirm = async (reason: string): Promise<void> => {
    try {
      await reverseDivergence({
        id: divergence.id,
        reason,
        version: divergence.version,
      }).unwrap();

      toast({
        description: REVERSAL_LABELS.SUCCESS,
        variant: "success",
        duration: 4000,
      });

      handleModal({ isOpen: false });
    } catch (error) {
      toast({
        description: extractRtkErrorMessage(error, REVERSAL_LABELS.ERROR),
        variant: "destructive",
        duration: 5000,
      });
    }
  };

  return (
    <ReversalModal
      effect={effect}
      isSubmitting={isLoading}
      onConfirm={(reason: string) => {
        void confirm(reason);
      }}
    />
  );
}
